import { PLAN_ROUTE_MAP, DEFAULT_ROUTE, ZOHO_DEFAULT_ROUTE } from "../constants/common";

export function getLandingPage(crmName, planName) {
    console.log(`inside  getLandingPage with camName: ${crmName}, planName: ${planName}`);
    const landingPageBaseUrl = process.env.REACT_APP_LANDING_PAGE_BASE_URL;
    if (crmName === "zoho") {
        return `${landingPageBaseUrl}${ZOHO_DEFAULT_ROUTE}`
    }
    let landingPage = PLAN_ROUTE_MAP[planName] || DEFAULT_ROUTE;
    return `${landingPageBaseUrl}${landingPage}`
}

export const ZIPPY_ENVS = ["dev", "qa", "staging", "aus_production"];
export const zipy_sdk_key = process.env.REACT_APP_ZIPY_SDK_KEY;
